import { getVideoApiBase } from './translatorHandoff';

export async function registerRoomSessionStart(roomId: string): Promise<number | null> {
  if (!roomId.trim()) {
    return null;
  }
  try {
    const apiBase = getVideoApiBase();
    const url = `${apiBase}/video/session-timer/register?roomId=${encodeURIComponent(roomId.trim())}`;
    const resp = await fetch(url, { method: 'POST' });
    if (!resp.ok) {
      return null;
    }
    const json = await resp.json();
    const epochMs = json?.sessionStartEpochMs;
    return typeof epochMs === 'number' && Number.isFinite(epochMs) ? epochMs : null;
  } catch {
    return null;
  }
}

export async function fetchRoomSessionStart(roomId: string): Promise<number | null> {
  if (!roomId.trim()) {
    return null;
  }
  try {
    const apiBase = getVideoApiBase();
    const url = `${apiBase}/video/session-timer/start?roomId=${encodeURIComponent(roomId.trim())}`;
    const resp = await fetch(url);
    if (!resp.ok) {
      return null;
    }
    const json = await resp.json();
    const epochMs = json?.sessionStartEpochMs;
    return typeof epochMs === 'number' && Number.isFinite(epochMs) ? epochMs : null;
  } catch {
    return null;
  }
}
